import { create } from 'zustand/react'

interface FormState {
    selectedRoutes: string[]
    selectedRowId: string | null
    draftCreatedReference: string | null
    newlyCreatedReference: string | null
    publishedDisruptionBanner: { reference: string; start: string } | null
}

interface FormActions {
    setSelectedRoutes: (routes: string[]) => void
    setSelectedRowId: (rowId: string) => void
    clearInputValues: () => void
    setDraftCreatedReference: (reference: string) => void
    clearDraftCreatedReference: () => void
    setNewlyCreatedReference: (reference: string) => void
    clearNewlyCreatedReference: () => void
    setPublishedDisruptionBanner: (banner: { reference: string; start: string }) => void
    clearPublishedDisruptionBanner: () => void
}

export const useDisruptionsTableFormStateStore = create<FormState & FormActions>()((set) => ({
    selectedRoutes: [],
    selectedRowId: null,
    draftCreatedReference: null,
    newlyCreatedReference: null,
    publishedDisruptionBanner: null,
    setSelectedRoutes: (routes: string[]) => set({ selectedRoutes: routes }),
    setSelectedRowId: (rowId: string) => set({ selectedRowId: rowId }),
    clearInputValues: () => {
        set({
            selectedRoutes: [],
            selectedRowId: null,
        })
    },
    setDraftCreatedReference: (reference: string) => set({ draftCreatedReference: reference }),
    clearDraftCreatedReference: () => set({ draftCreatedReference: null }),
    setNewlyCreatedReference: (reference: string) => set({ newlyCreatedReference: reference }),
    clearNewlyCreatedReference: () => set({ newlyCreatedReference: null }),
    setPublishedDisruptionBanner: (banner) => set({ publishedDisruptionBanner: banner }),
    clearPublishedDisruptionBanner: () => set({ publishedDisruptionBanner: null }),
}))
